import React, { useEffect, useState } from "react";
import { Api } from "../../../utils/Variables";
import axios from "axios";
import { ServiceUrl } from "../../../utils/ServiceUrl";

const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [showLoader, setLoader] = useState(true);
  const [announcement, setAnnouncement] = useState([]);

  const closeBar = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    axios
      .get(`${Api.Url}${ServiceUrl.ANNOUNCEMENT}`)
      .then((res) => {
        if (res.data.status === "1") {
          setAnnouncement(res.data.data); // expected: [{title: "..."}, {...}]
        }
      })
      .catch((error) => {
        console.error("Error fetching announcements", error);
      })
      .finally(() => setLoader(false));
  }, []);

  if (!isVisible) return null;

  return (
    <>
      {showLoader ? (
        <div className="announcement-skeleton-wrapper text-center">
          <div
            className="skeleton-bar"
            style={{ width: "80%", height: "20px", margin: "10px auto" }}
          ></div>
        </div>
      ) : announcement.length > 0 ? (
        <div className="announcement-bar">
          <div className="wrap-announcement-bar">
            <div className="box-sw-announcement-bar speed-1">
              {announcement.map((item, index) => (
                <div className="announcement-bar-item" key={index}>
                  <p>{item.title}</p>
                </div>
              ))}
            </div>
          </div>
          <span
            className="icon-close close-announcement-bar"
            onClick={closeBar}
          ></span>
        </div>
      ) : (
        <p className="text-center">
          {" "}
          <div className="announcement-skeleton-wrapper text-center">
            <div
              className="skeleton-bar"
              style={{ width: "80%", height: "20px", margin: "10px auto" }}
            ></div>
          </div>
        </p>
      )}
    </>
  );
};

export default AnnouncementBar;
